import { Link } from "react-router-dom";
import logoMark from "../assets/images/logoMark.svg";

function CallToAction() {
	return (
		<section className="callToActionSection desktopMaxWidth">
			<img src={logoMark} alt="Logo Mark" className="logoMark" />
			<p className="ctaText">
				Ready to take care of your mental health and future?
			</p>
			<Link
				to="/contact"
				aria-label="Book an Appointment"
				className="cta"
				// target="_blank"
				// rel="noopener noreferrer"
			>
				Book an Appointment
			</Link>
			<img src={logoMark} alt="Logo Mark Rotated" className="logoMarkRotated" />
		</section>
	);
}

export default CallToAction;
